import React from 'react';
import { calculateWizardCompletion } from './completionScore';

const CompletionBar = ({ data, currentStep }) => {
  const completionScore = calculateWizardCompletion(data);

  // Définir la couleur selon le score — bleu/neutre en début, vert en fin
  const getColor = () => {
    if (completionScore >= 80) return 'bg-green-500';
    if (completionScore >= 50) return 'bg-blue-500';
    return 'bg-blue-400';
  };

  return (
    <div className="bg-gradient-to-r from-blue-50 to-blue-50 border border-blue-200 rounded-lg p-4 mb-6 hidden md:block">
      <div className="flex items-center justify-between mb-2">
        <div>
          <span className="text-sm font-semibold text-gray-700">Complétion du bien</span>
          <p className="text-xs text-gray-500">Remplissez les informations pour améliorer le score</p>
        </div>
        <div className="text-2xl font-bold text-blue-600">{completionScore}%</div>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2.5">
        <div
          className={`h-2.5 rounded-full transition-all duration-500 ${getColor()}`}
          style={{ width: `${completionScore}%` }}
        ></div>
      </div>
    </div>
  );
};

export default CompletionBar;
